import { useAbmContext } from "../../views/abm/useAbmComponent"
import { ViewDetails } from "../details"

export const AbmViewDetails = () => {
  const {detailsData, itemDescription, selectedItem } = useAbmContext();
  const title = `Detalles: ${itemDescription(selectedItem)}`;
  return <ViewDetails data={detailsData} title={title} />
}